import _Model from "./_Model";

export default class SoftwareLicenceLink extends _Model {
  constructor(json) {
    super(json);
    this.label = SoftwareLicenceLink.getOrDefault(json, 'label', '');
    this.labelKey = SoftwareLicenceLink.getOrDefault(json, 'labelKey', '');
    this.licenceId = SoftwareLicenceLink.getOrDefault(json, 'licenceId', '');
    this.link = SoftwareLicenceLink.getOrDefault(json, 'link', '');
    this.softwareName = SoftwareLicenceLink.getOrDefault(json, 'softwareName', '');
    this.softwareNameKey = SoftwareLicenceLink.getOrDefault(json, 'softwareNameKey', '');
  }
}
